import { useSearchParams } from "react-router-dom";
import { useLang } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";
import { EventCard } from "../../components/site/EventCard";
import { PageHeader } from "./About";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

import { GEN } from "../../components/site/Img";
import { DateInput } from "../../components/site/DateInput";
import { useContent } from "../../lib/useFetch";

const IMG = GEN.marina;

const FilterSelect = ({ value, onChange, placeholder, options, testid }) => (
  <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
    <SelectTrigger className="h-12 rounded-full bg-white" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export default function Clinics() {
  const { t, tr } = useLang();
  const content = useContent();
  const [sp, setSp] = useSearchParams();
  const f = { class_name: sp.get("class") || "", location_id: sp.get("location") || "", type: sp.get("type") || "", date_from: sp.get("from") || "", date_to: sp.get("to") || "" };
  const set = (k, v) => { const n = new URLSearchParams(sp); v ? n.set(k, v) : n.delete(k); setSp(n); };
  const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
  const { data: events, loading } = useFetch(`/events?${qs}`);
  const visible = (events || []).filter((e) => e.status !== "Completed" || f.date_from || f.date_to);
  const { data: classes } = useFetch("/public/classes", { cached: true });
  const { data: locs } = useFetch("/public/locations", { cached: true });
  const { data: types } = useFetch("/public/event_types", { cached: true });

  const groups = {};
  visible.forEach((e) => {
    const k = e.start_date.slice(0, 7);
    (groups[k] = groups[k] || []).push(e);
  });

  return (
    <div data-testid="clinics-page">
      <PageHeader eyebrow="Calendar" title={t("calendar_title")} sub={t("calendar_sub")} img={content.images?.fields?.clinics_header || IMG} fallback={IMG} />
      <section className="container-x -mt-8 relative z-10">
        <div className="grid gap-3 rounded-3xl border border-slate-200 bg-white/90 p-4 shadow-xl backdrop-blur-xl md:grid-cols-6" data-testid="clinics-filters">
          <FilterSelect value={f.class_name} onChange={(v) => set("class", v)} placeholder={t("all_classes")} options={(classes || []).map((c) => [c.name, c.name])} testid="filter-class" />
          <FilterSelect value={f.location_id} onChange={(v) => set("location", v)} placeholder={t("all_locations")} options={(locs || []).map((l) => [l.id, l.name])} testid="filter-location" />
          <FilterSelect value={f.type} onChange={(v) => set("type", v)} placeholder={t("all_types")} options={(types || []).map((x) => [x.name, tr(x, "name")])} testid="filter-type" />
          <DateInput value={f.date_from} onChange={(v) => set("from", v)} className="w-44" inputClassName="h-12 rounded-full border-slate-200 bg-white px-4" data-testid="filter-date-from" aria-label={t("from")} />
          <DateInput value={f.date_to} min={f.date_from} onChange={(v) => set("to", v)} className="w-44" inputClassName="h-12 rounded-full border-slate-200 bg-white px-4" data-testid="filter-date-to" aria-label={t("to")} />
          <button onClick={() => setSp({})} className="h-12 rounded-full bg-[#0A2540] text-sm font-semibold text-white hover:bg-[#123a63]" data-testid="filter-reset">{t("reset")}</button>
        </div>
      </section>
      <section className="container-x py-16">
        {!loading && !visible.length && <p className="py-20 text-center text-slate-500" data-testid="clinics-empty">{t("no_events")}</p>}
        {Object.entries(groups).map(([month, evs]) => (
          <div key={month} className="mb-16 grid gap-8 lg:grid-cols-12">
            <div className="lg:col-span-2">
              <p className="sticky top-28 font-display text-3xl font-black uppercase text-[#0A2540]">
                {new Date(month + "-01T12:00:00").toLocaleDateString(undefined, { month: "short" })}
                <span className="block text-lg font-bold text-[#00A8B5]">{month.slice(0, 4)}</span>
              </p>
            </div>
            <div className="grid gap-6 sm:grid-cols-2 lg:col-span-10 xl:grid-cols-3">{evs.map((e) => <EventCard key={e.id} e={e} />)}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
